var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortTriangleDownActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14L4 9L12 9L8 14Z",
    fill: "#43494F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2L12 7L4 7L8 2Z",
    fill: "#C1C3C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortTriangleDownActive);
export default __webpack_public_path__ + "static/media/sort-triangle-down-active.c11415ce9fd4ca5871babea7f500bd0e.svg";
export { ForwardRef as ReactComponent };